module.exports = __webpack_public_path__ + "static/img/zz.53f20f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zz.jpg
// module id = 3AZN
// module chunks = 1